import { Component } from 'base/js/aem';

class animatedImages extends Component {
    init() {
        this.defaultWidth = 100;
        this.double = 2;
        if (this.isAuthorEnvironment()) {
            console.log('This is authoring.');
            this.displayStaticImages();
        } else if (this.prefersReducedMotion()) {
            this.displayStaticImages(true);
        } else {
            this.setupCarousel();
        }
    }

    /**
     * A list of standard speeds in an object to avoid "magic numbers".
     * @returns {{fast: number, slow: number, medium: number}}
     */
    getSpeeds() {
        return {
            fast: 1,
            medium: 0.5,
            slow: 0.2
        };
    }

    isAuthorEnvironment() {
        return window.Granite && window.Granite.author && window.Granite.author.MessageChannel;
    }

    prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    displayStaticImages(reduced = false) {
        const container = this.element.querySelector('.animatedImages-stage');
        if (!container) {
            return;
        }

        container.style.transform = '';
        container.style.transition = '';

        if (reduced) {
            const items = Array.from(container.children);
            items.forEach(item => {
                item.classList.remove('cloned');
                item.style.display = 'inline-block';
                item.style.margin = '1rem';
            });
            container.classList.add('animatedImages-static-fallback');
        } else {
            container.classList.remove('animatedImages-static-fallback');
        }
    }

    setupCarousel() {
        const container = this.element.querySelector('.animatedImages-stage');
        const items = Array.from(container.children).filter(child => child.querySelector('img'));
        if (!container || items.length === 0) {
            return;
        }

        const parentWidth = this.element.offsetWidth;
        const carousel = container.closest('.animatedImages-carousel');
        const direction = carousel?.classList.contains('dirRight') ? 'dirRight' : 'dirLeft';
        const speed = this.getSpeedMultiplier(carousel?.classList || []);

        this.cloneItems(container, items, parentWidth);
        this.animateCarousel(container, direction, speed);
    }

    cloneItems(container, items, parentWidth) {
        const itemWidth = items.length > 0 ? items[0].offsetWidth : this.defaultWidth;
        console.log(`first item width: ${items[0].offsetWidth}, default width: ${this.defaultWidth}`);
        const visibleItems = Math.ceil(parentWidth / itemWidth);
        console.log(`visible items: ${visibleItems}`);
        const requiredCopies = Math.ceil(visibleItems * this.double);
        console.log(`required copies: ${requiredCopies}`);

        Array.from(container.children).forEach(child => {
            if (child.classList?.contains('cloned')) {
                container.removeChild(child);
            }
        });

        for (let i = 0; i < requiredCopies; i++) {
            items.forEach(item => {
                const clone = item.cloneNode(true);
                clone.classList.add('cloned');
                container.appendChild(clone);
            });
        }

        container.style.width = `${(items.length + requiredCopies) * itemWidth}px`;
    }

    animateCarousel(container, direction, speed) {
        const totalWidth = container.scrollWidth - container.offsetWidth;
        let position = direction === 'dirRight' ? -totalWidth : 0;
        console.log(`total width: ${totalWidth}, position: ${position}`);

        const animate = () => {
            if (direction === 'dirLeft') {
                position -= speed;
                if (Math.abs(position) >= totalWidth) {
                    position = 0;
                }
            } else {
                position += speed;
                if (position >= 0) {
                    position = -totalWidth;
                }
            }

            container.style.transform = `translateX(${position}px)`;
            requestAnimationFrame(animate);
        };

        animate();
    }

    getSpeedMultiplier(classList) {
        const speeds = this.getSpeeds();
        if (classList.contains('speedFast')) {
            return speeds.fast;
        }
        if (classList.contains('speedSlow')) {
            return speeds.slow;
        }
        return speeds.medium;
    }
}

export { animatedImages };


